import React, { useEffect, useState, useContext, useCallback } from "react";
import "./RiskPremium.scss";
import { Button } from "react-bootstrap";
import axios from "axios";
import sizeMe from "react-sizeme";
import PerfectScrollbar from "react-perfect-scrollbar";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { POKTOOLS_API_URL } from "../PoktoolsVariables";
import { nFormatter } from "../../../api/ReplayVariables";
import { LoadingContext } from "../../../api/loading/LoadingContext";
import { PoktoolsContext } from "../poktoolsContext";
import { UserContext } from "../../../api/user/userContext";

const Loading = require("react-loading-animation");

function RiskPremium({ history, match, onShowLogin }) {
  const { user } = useContext(UserContext);
  const { poktoolsState, dispatchPoktoolsState } = useContext(PoktoolsContext);
  const [answers, setAnswers] = useState({});
  const { loading, dispatchLoading } = useContext(LoadingContext);
  const [data, setData] = useState(null);
  const [icmData, setIcmData] = useState([]);

  const [rp9, setRp9] = useState(0);

  const STACK_VS_STACK_THREASHOLD = 9;

  const [stacks, setStacks] = useState([2000, 1000, 500]);
  const [fullStacks, setFullStacks] = useState([2000, 1000, 500]);
  const [stackMultipliers, setStackMultipliers] = useState([1, 1, 1]);
  const [stacksValid, setStacksValid] = useState(true);

  const recalculateFullStacks = useCallback(() => {
    let _stacks = [];
    for (let k = 0; k < stacks.length; k++) {
      let stack = stacks[k];
      let multiplier = stackMultipliers[k];
      //console.log(stack, multiplier);
      for (let j = 0; j < multiplier; j++) {
        _stacks.push(stack);
      }
    }
    //console.log("recalculateFullStacks", _stacks.length);
    setFullStacks(_stacks);
  }, [stackMultipliers, stacks]);

  const onStackChange = (index, stack) => {
    if (stack >= 0) {
      let _stacks = JSON.parse(JSON.stringify(stacks));
      _stacks[index] = stack;
      setStacks(_stacks);
      let valid = stacks.length > 1;
      for (let st of _stacks) {
        if (st <= 0) {
          valid = false;
        }
      }
      setStacksValid(valid);
    }
  };
  const addStack = () =>
  {
    if (fullStacks.length < 9) {
      let _stacks = JSON.parse(JSON.stringify(stacks));
      _stacks.push(stacks[stacks.length - 1]);
      setStacks(_stacks);
      let _multipliers = JSON.parse(JSON.stringify(stackMultipliers));
      _multipliers.push(1);
      setStackMultipliers(_multipliers);
    }
  };
  const deleteStack = (index) => {
    let _stacks = JSON.parse(JSON.stringify(stacks));
    _stacks.splice(index, 1);
    if (_stacks.length === 0) {
      _stacks.push("");
    }
    setStacks(_stacks);

    let _multipliers = JSON.parse(JSON.stringify(stackMultipliers));
    _multipliers.splice(index, 1);
    if (_multipliers.length === 0) {
      _multipliers.push(1);
    }
    setStackMultipliers(_multipliers);

    if (index === posX) {
      setPosX(-1);
      setPosY(-1);
    } else if (index === posY) {
      setPosY(-1);
    } else {
      if (index < posX) {
        setPosX(posX - 1);
      }
      if (index < posY) {
        setPosY(posY - 1);
      }
    }
    let valid = stacks.length > 1;
    for (let st of _stacks) {
      if (st <= 0) {
        valid = false;
      }
    }
    setStacksValid(valid);
  };

  const onStackMultiplierChange = (index, multiplier) => {
    //console.log("onStackMultiplierChange " + index, multiplier);
    if (multiplier > 0) {
      let _stacks = [];
      for (let k = 0; k < stacks.length; k++) {
        if (k !== index) {
          let stack = stacks[k];
          let multiplier = stackMultipliers[k];
          //console.log(stack, multiplier);
          for (let j = 0; j < multiplier; j++) {
            _stacks.push(stack);
          }
        }
      }
      //console.log("recalculateFullStacks", _stacks.length);
      if (_stacks.length + multiplier <= 9) {
        let _multipliers = JSON.parse(JSON.stringify(stackMultipliers));
        _multipliers[index] = multiplier;
        setStackMultipliers(_multipliers);
      }
    }
  };

  const [payouts, setPayouts] = useState([200, 100]);
  const [fullPayouts, setFullPayouts] = useState([200, 100]);
  const [payoutMultipliers, setPayoutMultipliers] = useState([1, 1]);
  const [payoutsValid, setPayoutsValid] = useState(true);

  const recalculateFullPayouts = useCallback(() => {
    let _payouts = [];
    for (let k = 0; k < payouts.length; k++) {
      let payout = payouts[k];
      let multiplier = payoutMultipliers[k];
      //console.log(payout, multiplier);
      for (let j = 0; j < multiplier; j++) {
        _payouts.push(payout);
      }
    }
    //console.log("recalculateFullPayouts", _payouts.length);
    setFullPayouts(_payouts);
  }, [payoutMultipliers, payouts]);

  const onPayoutChange = (index, payout) => {
    if (payout >= 0) {
      let _payouts = JSON.parse(JSON.stringify(payouts));
      _payouts[index] = payout;
      setPayouts(_payouts);
      let valid = payouts.length > 0;
      for (let st of _payouts) {
        if (st <= 0) {
          valid = false;
        }
      }
      setPayoutsValid(valid);
    }
  };
  const addPayout = () => {
    if (payouts.length < 9)
    {
      let _payouts = JSON.parse(JSON.stringify(payouts));
      _payouts.push(payouts[payouts.length - 1]);
      setPayouts(_payouts);
      let _multipliers = JSON.parse(JSON.stringify(payoutMultipliers));
      _multipliers.push(1);
      setPayoutMultipliers(_multipliers);
    }
  };
  const deletePayout = (index) => {
    let _payouts = JSON.parse(JSON.stringify(payouts));
    _payouts.splice(index, 1);
    if (_payouts.length === 0) {
      _payouts.push("");
    }
    setPayouts(_payouts);
    let valid = payouts.length > 0;
    for (let st of _payouts) {
      if (st <= 0) {
        valid = false;
      }
    }
    setPayoutsValid(valid);

    let _multipliers = JSON.parse(JSON.stringify(payoutMultipliers));
    _multipliers.splice(index, 1);
    if (_multipliers.length === 0) {
      _multipliers.push(1);
    }
    setPayoutMultipliers(_multipliers);
  };

  const [posX, setPosX] = useState(-1);
  const [posY, setPosY] = useState(-1);

  const { t } = useTranslation();

  const showError = useCallback(
    (message) => {
      toast.error(t("poktools.error") + " : " + message, {
        position: "bottom-right",
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false, 
        draggable: false,
        progress: 0
      });
    },
    [t]
  );

  const fetchData = useCallback(() => {
    let key = {
      rp: 1,
      stacks: fullStacks.join(","),
      payouts: fullPayouts.join(",")
    };

    if (fullStacks.length > STACK_VS_STACK_THREASHOLD) {
      key["posx"] = fullStacks[posX];
      key["posy"] = fullStacks[posY];
    }
    if (answers[JSON.stringify(key)]) {
      let _data = answers[JSON.stringify(key)];
      setData((da) => _data);
      let _icmData = [];
      let _stacks = [];
      for (let index = 0; index < fullStacks.length; index++) {
        if (_stacks.indexOf(_data[index].stack) === -1) {
          _data[index]["multiplier"] = 0;
          for (let index2 = 0; index2 < fullStacks.length; index2++) {
            if (fullStacks[index2] === _data[index].stack) {
              _data[index]["multiplier"]++;
            }
          }
          _stacks.push(_data[index].stack);
          _icmData.push(_data[index]);
        }
      }
      setIcmData((da) => _icmData);
      dispatchLoading({ type: "update", payload: 100 });
      return;
    }
    //FETCH HAND DETAILS
    dispatchLoading({ type: "update", payload: 10 });
    axios({
      method: "post",
      headers: {
        "X-USER-POKTOOLS": poktoolsState.xUserPoktools,
        "X-PARTNER-POKTOOLS": poktoolsState.xPartnerPoktools,
        "X-PASS-POKTOOLS": poktoolsState.xPassPoktools,
        "x-xeester-licence": poktoolsState.xXeesterLicence,
        Accept: "*/*",
        "content-type": "application/x-www-form-urlencoded"
      },
      params: key,
      mode: "cors",
      url: POKTOOLS_API_URL + "icmrp"
    })
      .then((resp) => {
        if (resp.data.errorCode) {
          dispatchLoading({ type: "update", payload: 100 });
          showError("FETCH");
        } else {
          let _data = [];
          for (let index = 0; index < fullStacks.length; index++) {
            let dt = {
              stack: resp.data.rpResult[index].stack,
              icm: resp.data.rpResult[index].icm
            };
            if (fullStacks.length <= STACK_VS_STACK_THREASHOLD) {
              for (let index2 = 0; index2 < fullStacks.length; index2++) {
                if (index !== index2) {
                  dt["vs" + index2] =
                    resp.data.rpResult.rp[index + "vs" + index2].rp;
                }
              }
            }
            _data.push(dt);
          }
          if (fullStacks.length > STACK_VS_STACK_THREASHOLD) {
            let _rp9 = resp.data.rpResult.rp[posX + "vs" + posY].rp;
            console.log("_rp9", _rp9);
            setRp9(_rp9);
          }
          key.rp = 0;
          axios({
            method: "post",
            headers: {
              "X-USER-POKTOOLS": poktoolsState.xUserPoktools,
              "X-PARTNER-POKTOOLS": poktoolsState.xPartnerPoktools,
              "X-PASS-POKTOOLS": poktoolsState.xPassPoktools,
              "x-xeester-licence": poktoolsState.xXeesterLicence,
              Accept: "*/*",
              "content-type": "application/x-www-form-urlencoded"
            },
            params: key,
            mode: "cors",
            url: POKTOOLS_API_URL + "icmrp"
          })
            .then((resp) => {
              if (resp.data.errorCode) {
                dispatchLoading({ type: "update", payload: 100 });
                showError("FETCH");
              } else {
                //console.log("icm", resp.data);
                let _icmData = [];
                let _stacks = [];
                for (let index = 0; index < fullStacks.length; index++) {
                  if (_stacks.indexOf(_data[index].stack) === -1) {
                    _data[index]["prorata"] =
                      resp.data.rpResult[index].value_dolz;
                    _data[index]["chips"] =
                      resp.data.rpResult[index].value_stack;
                    _data[index]["multiplier"] = 0;
                    for (let index2 = 0; index2 < fullStacks.length; index2++) {
                      if (fullStacks[index2] === _data[index].stack) {
                        _data[index]["multiplier"]++;
                      }
                    }
                    _stacks.push(_data[index].stack);
                    _icmData.push(_data[index]);
                  }
                }
                setData((da) => _data);
                setIcmData((da) => _icmData);
                //console.log("data", JSON.stringify(_data));
                let _answers = JSON.parse(JSON.stringify(answers));
                _answers[JSON.stringify(key)] = _data;
                setAnswers((a) => _answers);
                dispatchLoading({ type: "update", payload: 100 });
              }
            })
            .catch((err) => {
              console.error("fetch problem", err);
              dispatchLoading({ type: "update", payload: 100 });
              showError(resp.data.errorCode);
            });
        }
      })
      .catch((err) => {
        console.error("fetch problem", err);
        dispatchLoading({ type: "update", payload: 100 });
        showError("FETCH");
      });
  }, [
    fullStacks,
    fullPayouts,
    answers,
    dispatchLoading,
    poktoolsState.xUserPoktools,
    poktoolsState.xPartnerPoktools,
    poktoolsState.xPassPoktools,
    poktoolsState.xXeesterLicence,
    posX,
    posY,
    showError
  ]);

  const reset = () => {
    setData(null);
    setStacks([""]);
    setPayouts([""]);
    setFullStacks([]);
    setPosX(-1);
    setPosY(-1);
    setStacksValid(false);
    setPayoutsValid(false);
  };
  const showLogin = useCallback(() => {
    onShowLogin();
  }, [onShowLogin]);

  useEffect(() => {
    let urls = {
      home: window.poktoolsLastUrls.home,
      trainer: window.poktoolsLastUrls.trainer,
      fastpok: window.poktoolsLastUrls.fastpok,
      rp: window.poktoolsLastUrls.rp
    };
    urls.rp = document.location.href.substring(
      document.location.href.indexOf("/app/poktools/")+ 14
    );
    window.poktoolsLastUrls = urls;

    if (match.params.tab === "form") {
      recalculateFullStacks();
      recalculateFullPayouts();
    }
    dispatchLoading({ type: "update", payload: 100 });

    return () => {
      //console.log("riskpremium done");
    };
  }, [
    data,
    dispatchLoading,
    dispatchPoktoolsState,
    poktoolsState.xPassPoktools,
    poktoolsState.xUserPoktools,
    recalculateFullStacks,
    recalculateFullPayouts,
    showLogin,
    user.crypt,
    user.error,
    match.params.tab
  ]);

  return (
    <div id="riskpremium">
      <div
        className="back"
        onClick={() => {
          history.push("/app/poktools/home");
        }}
      >
        &lt; <span className="back-text">{t("poktools.back")}</span>
      </div>
      <PerfectScrollbar>
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover={false}
        />
        <div
          className={
            "riskpremium-loading-container" +
            (loading.progress === 100 ? " done" : "")
          }
        >
          <div>
            <Loading></Loading>
          </div>
        </div>
        <div id="riskpremium-top">
          <div id="riskpremium-container">
            <div className="structure">
              <div className="stacks align-top">
                <div className="title">
                  {t("poktools.rp.stacks")} ({fullStacks.length}/9)
                </div>
                <Button disabled={fullStacks.length >=9} onClick={addStack}>{t("poktools.rp.add")}</Button>
                {stacks.map((stack, index) => (
                  <div
                    key={index}
                    className={"stack" + (stack <= 0 ? " invalid" : "")}
                  >
                    <input
                      id={"stack" + index}
                      type="number"
                      autoFocus
                      min={0}
                      step={10}
                      value={stack}
                      onChange={(e) => onStackChange(index, e.target.value)}
                      onKeyPress={(evt) => {
                        if (evt.key === "Enter") {
                          addStack();
                        }
                      }}
                    />
                    <div>&nbsp;x&nbsp;</div>
                    <input
                      className="multiplier"
                      id={"stackmultiplier" + index}
                      type="number"
                      min={1}
                      step={1}
                      value={stackMultipliers[index]}
                      onChange={(e) => {
                        onStackMultiplierChange(
                          index,
                          parseInt(e.target.value)
                        );
                      }}
                    />
                    <div className="delete" onClick={() => deleteStack(index)}>
                      X
                    </div>
                  </div>
                ))}
              </div>
              <div className="payouts align-top">
                <div className="title">
                  {t("poktools.rp.payouts")} ({payouts.length})
                </div>
                <Button disabled={payouts.length >=9} onClick={addPayout}>{t("poktools.rp.add")}</Button>
                {payouts.map((payout, index) => (
                  <div
                    key={index}
                    className={"payout" + (payout <= 0 ? " invalid" : "")}
                  >
                    <input
                      type="number"
                      autoFocus
                      min={0}
                      step={10}
                      value={payout}
                      onChange={(e) => onPayoutChange(index, e.target.value)}
                      onKeyPress={(evt) => {
                        if (evt.key === "Enter") {
                          addPayout();
                        }
                      }}
                    />
                    <div
                      className="multiplier"
                    >&nbsp;Place {index+1}</div>
                    <div className="delete" onClick={() => deletePayout(index)}>
                      X
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {fullStacks.length > STACK_VS_STACK_THREASHOLD ? (
              <div className="positions">
                <div className="warning">{t("poktools.rp.warning")}</div>
                <div className="positions-select">
                  <input
                    type="number"
                    placeholder="Stack 1"
                    autoFocus
                    min={0}
                    defaultValue=""
                    onChange={(e) => {
                      let value = parseInt(e.target.value);
                      let index = fullStacks.indexOf(value);
                      if (index !== -1) {
                        setPosX(index);
                        if (index === posY) {
                          setPosY(-1);
                        }
                      } else {
                        setPosX(-1);
                      }
                    }}
                    className={posX === -1 ? "invalid" : ""}
                  />

                  <div>&nbsp;VS&nbsp;</div>
                  <input
                    type="number"
                    placeholder="Stack 2"
                    autoFocus
                    min={0}
                    defaultValue=""
                    onChange={(e) => {
                      let value = parseInt(e.target.value);
                      let index = fullStacks.indexOf(value);
                      console.log("index", index);
                      if (index !== -1) {
                        if (index === posX) {
                          index = fullStacks.lastIndexOf(value);
                          console.log("index2", index);
                          if (index !== posX) {
                            setPosY(index);
                          } else {
                            setPosY(-1);
                          }
                        } else {
                          setPosY(index);
                        }
                      } else {
                        setPosY(-1);
                      }
                    }}
                    className={posY === -1 ? "invalid" : ""}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="actions">
              <Button
                onClick={fetchData}
                disabled={
                  !stacksValid ||
                  !payoutsValid ||
                  (fullStacks.length > STACK_VS_STACK_THREASHOLD &&
                    (posX === -1 || posY === -1))
                }
              >
                {t("poktools.rp.calculate")}
              </Button>
              <Button className="reset" onClick={reset}>
                {t("poktools.rp.reset")}
              </Button>
            </div>
            {data !== null ? (
              <>
                {fullStacks.length <= STACK_VS_STACK_THREASHOLD ? (
                  <table className="results">
                    <thead>
                      <tr>
                        <td
                          style={{
                            width: nFormatter(100 / (data.length + 1)) + "%"
                          }}
                        >
                          ICM$
                        </td>
                        {data.map((dt, index) => (
                          <td key={index}>{nFormatter(dt.icm)}</td>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="header">
                        <td>RP</td>
                        {data.map((dt, index) => (
                          <td key={index}>{dt.stack}</td>
                        ))}
                      </tr>
                      {data.map((dt, index) => (
                        <tr key={index}>
                          <td>{dt.stack}</td>
                          {data.map((dt2, index2) => (
                            <td
                              key={index2}
                              className={
                                "data-cell" + (index === index2 ? " same" : "")
                              }
                            >
                              {index === index2
                                ? ""
                                : nFormatter(dt["vs" + index2]) + " %"}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="sections">
                    <section>
                      {nFormatter(fullStacks[posX])} vs{" "}
                      {nFormatter(fullStacks[posY])}
                    </section>
                    <section>Risk Premium : {nFormatter(rp9)} %</section>
                  </div>
                )}
                <table className="results">
                  <thead>
                    <tr>
                      <td>{t("poktools.rp.stacks")}</td>
                      <td>ICM $</td>
                      <td>{t("poktools.rp.prorata")} $</td>
                      <td>{t("poktools.rp.chips")} %</td>
                    </tr>
                  </thead>
                  <tbody>
                    {icmData.map((dt, index) => (
                      <tr key={index}>
                        <td>
                          {dt.stack}{" "}
                          {dt.multiplier > 1 ? " x " + dt.multiplier : ""}
                        </td>
                        <td>{nFormatter(dt.icm)}</td>
                        <td>{nFormatter(dt.prorata)}</td>
                        <td>{nFormatter(dt.chips)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
}
export default sizeMe({
  monitorHeight: true,
  monitorWidth: true,
  monitorPosition: true
})(RiskPremium);
